import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { groupNameMessage } from '../../../styles/CommonStyles';
import { SiteSettingsForSiteAdminProps } from '../ReactSiteSettingsForSiteAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';
import { forceUncheckedIfUserVisibilityLimited, useUserVisibilityLimited } from './UserVisibilitySection';

export const REQUEST_ACCESS_FIELD = 'settings.requestAccessEnabled';

export type RequestAccessSectionProps = SiteSettingsForSiteAdminProps<'requestAccessEnabled' | 'userVisibility'>;

export function RequestAccessSection() {
  const isUserVisibilityLimited = useUserVisibilityLimited();
  return FeatureFlags.requestAccessEnabled
    ? (
      <SettingsSection title={renderTitle(isUserVisibilityLimited)}
                       testId={'request-access-setting-section'}
                       description={Messages.requestAccessDetails()}
                       disabled={isUserVisibilityLimited}>
        <FormikCheckbox
                    name={REQUEST_ACCESS_FIELD}
                    label={Messages.requestAccessEnabled()}
                    testId={'request-access-checkbox'}
                    disabled={isUserVisibilityLimited}
                    {...forceUncheckedIfUserVisibilityLimited(isUserVisibilityLimited)}
        />
      </SettingsSection>
    )
    : null;
}

function renderTitle(userVisibilityLimited: boolean) {
  return <>
    <span>{Messages.requestAccess()}</span>
    {userVisibilityLimited &&
    <span className={groupNameMessage} data-tb-test-id={'requestaccess-uservisibility-warning'}>
      {Messages.userVisibilityWarning()}
    </span>}
  </>;
}

export const RequestAccessSectionSpecs = componentRegistryEntry({
  name: 'RequestAccessSection',
  component: RequestAccessSection
});
